import React from 'react';
import 'twin.macro';
import { AdChannel } from 'types/adTypes';
import { VacancyChannelRecovery } from 'utils/vacancyChannels';

const channelLabel = (channel: AdChannel) =>
  channel === AdChannel.TIKTOK
    ? 'TikTok'
    : channel === AdChannel.LINKEDIN
    ? 'LinkedIn'
    : channel.charAt(0) + channel.slice(1).toLowerCase();

const ChannelChangeRecovery = ({
  recoveries,
  retryChange,
}: {
  recoveries: VacancyChannelRecovery[];
  retryChange: (channel?: AdChannel) => Promise<void>;
}) => (
  <>
    {recoveries.map(({ channel, recorded, disabled }) => (
      <div key={channel} tw="text-sm text-orange-700">
        <p>
          {channelLabel(channel)}:{' '}
          {recorded
            ? 'The channel change could not be completed. You can retry it or choose different channels.'
            : 'The channel change could not be confirmed.'}
        </p>
        <button
          type="button"
          tw="underline"
          disabled={disabled}
          aria-label={
            recoveries.length > 1
              ? `Retry ${channelLabel(channel)} channel change`
              : undefined
          }
          onClick={() => retryChange(channel)}
        >
          Retry channel change
        </button>
      </div>
    ))}
  </>
);
export default ChannelChangeRecovery;
